const Table = () => import('@/../../coreui/components/ServerTable')

export default function buildMenu (allowed) {
  return [
    {
      path: '/OpsEngineering',
      name: 'OpsEngineering',
      component: Table,
      props: {
        schema: 'sch_dev_todo', 
        table: 'dev_todo'
      } 
    },
    {
      path: '/OpsEnhancements',
      name: 'OpsEnhancements',
      component: Table,
      props: {
        schema: 'sch_dev_enhancements', 
        table: 'dev_enhancements'
      } 
    },
    {
      path: '/OpsMarketing',
      name: 'OpsMarketing',
      component: Table,
      props: {
        schema: 'sch_dev_todo', 
        table: 'ops_mktg_todo'
      } 
    },
    {
      path: '/OpsSales',
      name: 'OpsSales',
      component: Table,
      props: {
        schema: 'sch_dev_todo', 
        table: 'ops_sales_todo'
      }
    }
  ]
}
